import { selectStandardProps } from "@/utils/componentUtils";
import { Form, Select } from "antd";
import { FormItemProps } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";
import { useTranslation } from "react-i18next";
import { useEnumeration } from "../../../../common/api/queries";
import type { UUID } from "../../../../typings/global";
import { EnumerationType } from "../../enums";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<string>;
  institutionId: UUID;
}

const ComplicitySelect = ({ formItemProps, selectProps, institutionId }: Props) => {
  const { t } = useTranslation();

  const complicityEnums = useEnumeration(EnumerationType.COMPLICITIES);

  const resolveComplicitiesByDeactivated = (deactivated: boolean) => {
    return complicityEnums
      .filter((complicity) => complicity.institutionId === institutionId)
      .filter((complicity) => complicity.deactivated === deactivated);
  };

  const activeComplicities = resolveComplicitiesByDeactivated(false);
  const deactivatedComplicities = resolveComplicitiesByDeactivated(true);

  return (
    <Form.Item {...formItemProps}>
      <Select
        {...selectStandardProps}
        {...selectProps}
        options={[
          ...(activeComplicities.length > 0
            ? [
                {
                  label: t("complicity.helpers.activated"),
                  options: activeComplicities.map((complicity) => ({ value: complicity.id, label: complicity.value })),
                },
              ]
            : []),
          ...(deactivatedComplicities.length > 0
            ? [
                {
                  label: t("complicity.helpers.deactivated"),
                  options: deactivatedComplicities.map((complicity) => ({
                    value: complicity.id,
                    label: complicity.value,
                  })),
                },
              ]
            : []),
        ]}
      />
    </Form.Item>
  );
};

export default ComplicitySelect;
